module.exports = __webpack_public_path__ + "assets/retina_TriangleMidSegmentDetailed.ad16d66aa2b6f79071f11ea7050fee8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TriangleMidSegmentDetailed.png
// module id = 751
// module chunks = 0